<template>
<div>
    <card>
        <template slot="header">
            <i class="material-icons">lock</i>
            <strong class="ml-2">Page Not Found</strong>
        </template>

        <template slot="body">
            The page you requested could not be found. Sorry about that!
            <br /><br />
            Please click <router-link to="/">here</router-link> to go home.
        </template>
    </card>
</div>
</template>

<script>
export default {
    name: "not-found-page",

    mounted () {
        let params

        params = new URLSearchParams()

        params.append("path", window.location.pathname)
        params.append("referrer", document.referrer)

        // this.$http("/api/page-404s", { method: "POST", data: params })
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/NotFoundPage.vue